import React, { useEffect, useRef } from "react";
import * as pbi from "powerbi-client";
import { models, service } from "powerbi-client";

export default function ReportEmbedManual({ embedData }) {
  const reportRef = useRef(null);

  useEffect(() => {
      if (embedData && reportRef.current) {
        const url = new URL(embedData.embedUrl);
        const reportId = url.searchParams.get("reportId");
  
        const embedConfig = {
          type: "report",
          id: reportId,
          embedUrl: embedData.embedUrl,
          accessToken: embedData.token,   // ✅ must be the actual token string
          tokenType: models.TokenType.Embed,
          settings: {
            panes: {
              filters: { visible: false },
              pageNavigation: { visible: true }
            }
          }
        };
  
        const powerbiService = new service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory
        );
  
        powerbiService.embed(reportRef.current, embedConfig);
      }
    }, [embedData])

  return <div ref={reportRef} style={{ height: "100vh", width: "100%" }} />;
}


// ReportEmbed.jsx
// import React from "react";
// import { PowerBIEmbed } from "powerbi-client-react";
// import { models } from "powerbi-client";

// const PowerBIEmbeddedReport = ({ embedUrl, token, reportId }) => {
//   return (
//     <div style={{ height: "100vh", width: "100%" }}>
//       <PowerBIEmbed
//         embedConfig={{
//           type: "report", // Can be dashboard, tile, etc.
//           id: reportId,   // Extracted from your API response
//           embedUrl: embedUrl,
//           accessToken: token,
//           tokenType: models.TokenType.Embed,
//           settings: {
//             panes: {
//               filters: { visible: false },
//               pageNavigation: { visible: true }
//             }
//           }
//         }}
//         cssClassName="report-style-class"
//         getEmbeddedComponent={(embeddedReport) => {
//           console.log("Report instance:", embeddedReport);
//         }}
//       />
//     </div>
//   );
// };

// export default PowerBIEmbeddedReport;
 



// Copyright (c) Microsoft Corporation.
// // Licensed under the MIT License.

// import React, { useState } from "react";
// import { models } from "powerbi-client";
// import { PowerBIEmbed } from "powerbi-client-react";

// import * as portals from "react-reverse-portal";

// import "./reports.css";

// // Root Component to demonstrate usage of wrapper component
// function PowerBIEmbeddedReport() {
//   const portalNode = React.useMemo(() => portals.createHtmlPortalNode(), []);
//   // PowerBI Report object (to be received via callback)
//   const [, setReport] = useState();
//   const [position, setPosition] = useState("middle");

//   // API end-point url to get embed config for a sample report
//   // const sampleReportUrl = "https://playground.powerbi.com/sampleReportEmbed";

//   // Report config useState hook
//   // Values for properties like embedUrl, accessToken and settings will be set on click of buttons below
//   const [sampleReportConfig, setReportConfig] = useState({
//     // type: "report",
//     // embedUrl: "https://app.powerbi.com/groups/9a92f451-6883-49fa-b3c7-0af3c6009c44/reports/9d4a6a71-cbad-4b14-82a6-7448a0c98cfb/3ec0b490c3a713788815?experience=power-bi&noSignUpCheck=1&UPN=reports%40pepsico.com",
//     // tokenType: models.TokenType.Aad,
//     // id: null,
//     // accessToken: "",
//       type: 'report',   // Supported types: report, dashboard, tile, visual and qna
//       // id: 'a7ab29a3-02c7-4c45-81a8-e756e9897d79',
//       embedUrl: "https://app.powerbi.com/reportEmbed?reportId=9d4a6a71-cbad-4b14-82a6-7448a0c98cfb&groupId=9a92f451-6883-49fa-b3c7-0af3c6009c44&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLU5PUlRILUNFTlRSQUwtRS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZX19",
//       accessToken: 'H4sIAAAAAAAEACWTx66rWAJF_-VOaQlMpqU3wHDIYIzJs0MONuGQDKX6975dNV-DraW1__px4fkeYfHz3x-GGb0oyK1vGUFW79uJkQ4mrr7RXXApETzFs2bmo-8rddFzW5c4OFhbVNeCVNqSnLGc9tlwV09Hw24DU0H0d1YeCkO2n3aZsqWOFpJ6j3a5JJ1CoeChmGvqlcz1nL9hu31kSb3DW07Vhg0t0gTiS1MywA66p4fG2T_025qtKz1HFIR5LO0JQz76s6DKkxtxfw0HVBx8lFbHm9RcGTpFD_nbpcm8xewF5VIdHGWWwnOyOtLsmqr9gkS3CR2IpZFpVWW-CNsHrVRlrEdTRHEX8DTSlfeqZiAAApHY5iIoi6e_QqLOSpC00ooqGbsStCjdxzfcvFf1RQcNmizVMJ5OWYKJr_Ov5trCs7tzEmzbj2SPbCHSHS01RojjR2ICBjzoPpgugXR78M2m5_mmuY6-3tqcbWN0xlsC4OSSt8fA8bH6ldkuPhF6UbKQlQyq5qMZmaeznbqC-7eQ3yvxG1brBvNMvV5jUa857EGjFMNGBoy_E_78YYq7p6G92UDs2XZGXvGhppACtMkmb1pwtrreXlWecCFPqJubIylTqYk2seMahqK8Fn_XsI3GCqWz63Q2VfkVbzGBIbnKQmfvWY0IdThihWZj91W8m1l_mneLFTQo-eC2rLKlxqTt5qJVd3SDZE1SUiFk3EfCMFuT2V_sK-3hYguk_-FEN4JWTyjVxGHn1U-MOR3ggwvA_nJFqzYOHgL4gql0Ux3PwzE8mCSFzTu6qybd8A_34b3B6RvchltSq2TzkV7aRU1UQ_RzIwC8SamFIpzdkt-pUWEXV9CYai2kv-9EzD5VQbpAGbJDSs2ujt4ae-cTz75-5yxJNQo7sptYFdrmaylclJe844F7p28pX__58_OfHwmd0zqa5fl7sxfaP-huO59-onx1J0ZO7y2Nq00FZNMMyUAtxtoLkti0wsDI8lQy69vN6qmpvZMvpAmrCt3QCH6rJQ23N3Zl3uPi9zKA6QA4yQbZ-g5XwPdkclIUhzGz4foMO_PJMGRvNohtxpsLVv4EYvnkuXoFMDzgsXBZN6MgHHUNiSPlPOlm7LaAynzmsk_0eiQ3o8RrgTorQ8XpRaNX4CHFf2WpT8vnZ16M3JFnkbBAlIiWG3Rw8ymIuS4TxUS_p27W1XaZfN4FbzwlRZOE4HTJoZ84yi96O5d2X0LDWmZVV10-GMIxI14lwzR14jvj-PDbFEc6aY0bc9EaMO1PlGPDSMbdlxP_1XxOTYn08NeyNYUhNV0mQasmFWmMqfQY9vyHerX1ANcNlb_YpjbvsbIVQmQdNy-Ni43ctckeKS9tL_NgFKrspxC6jsTcEckVzUQl1W-HX7zlv6-yEaoSSsTyzApEB_jCYaiWIpXBG26U5vmLFEW9XWRr0KEiDj4rGt2dZv0AccmbcsFZlw4L7wt55dSz6WLDDFV3eRx-6FWc2G4Be9qgLNQPehF6CjZ8bbdygFykhFn6UD7g-bJIiwkjly8c_Znzd3vSbF4oQj0zPPeh6QMZOIVWYJbJZdOh4VnxtLR0R8ucGG44W6GQK97uw0dJ1LGYQ8mrzYcvCDe-k7qb8NRmj_nexyo8K3kgcvdBhrdhzoxLUuUFHSWYPa5jCSIZ-2M0HlHe5fLn_5r__h92T6bOWgYAAA==.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLU5PUlRILUNFTlRSQUwtRS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZXhwIjoxNzU0NTA1MzYzLCJhbGxvd0FjY2Vzc092ZXJQdWJsaWNJbnRlcm5ldCI6dHJ1ZX0=',
//       tokenType: models.TokenType.Embed,
//       settings: {
//         panes: {
//           filters: {
//             expanded: false,
//             visible: true
//           }
//         },
//       }
//   });

//   const TopComponent = ({ position }) => {
//     return position === "top" ? <portals.OutPortal node={portalNode} /> : null;
//   };

//   const MiddleComponent = ({ position }) => {
//     return position === "middle" ? (
//       <portals.OutPortal node={portalNode} />
//     ) : null;
//   };

//   // Map of event handlers to be applied to the embedding report
//   const eventHandlersMap = new Map([
//     [
//       "loaded",
//       function () {
//         console.log("Report has loaded");
//       },
//     ],
//     [
//       "rendered",
//       function () {
//         console.log("Report has rendered");

//         // Update display message
//         setMessage("The report is rendered");
//       },
//     ],
//     [
//       "error",
//       function (event) {
//         if (event) {
//           console.error(event.detail);
//         }
//       },
//     ],
//   ]);

//   // Fetch sample report's config (eg. embedUrl and AccessToken) for embedding
//   // const mockSignIn = async () => {
//   //   // Fetch sample report's embed config
//   //   const reportConfigResponse = await fetch(sampleReportUrl);

//   //   if (!reportConfigResponse.ok) {
//   //     console.error(
//   //       `Failed to fetch config for report. Status: ${reportConfigResponse.status} ${reportConfigResponse.statusText}`
//   //     );
//   //     return;
//   //   }

//   //   const reportConfig = await reportConfigResponse.json();

//   //   // Update display message
//   //   setMessage(
//   //     "The access token is successfully set. Loading the Power BI report"
//   //   );

//   //   // Set the fetched embedUrl and embedToken in the report config
//   //   setReportConfig({
//   //     ...sampleReportConfig,
//   //     embedUrl: reportConfig.EmbedUrl,
//   //     accessToken: reportConfig.EmbedToken.Token,
//   //   });
//   // };

//   // const changeSettings = () => {
//   //   // Update the state "sampleReportConfig" and re-render DemoApp component
//   //   setReportConfig({
//   //     ...sampleReportConfig,
//   //     settings: {
//   //       panes: {
//   //         filters: {
//   //           expanded: false,
//   //           visible: false,
//   //         },
//   //       },
//   //     },
//   //   });
//   // };

//   // const changeReportPosition = () => {
//   //   const newPosition = position === "middle" ? "top" : "middle";
//   //   setPosition(newPosition);
//   // };

//   const [displayMessage, setMessage] = useState(
//     `The report is bootstrapped. Click the Embed Report button to set the access token`
//   );

//   const controlButtons = (
//     <div className="controls">
//       {/* <button className="control-button" onClick={mockSignIn}>Embed Report</button>

//       <button className="control-button" onClick={changeSettings}>Hide filter pane</button>

//       <button className="control-button" onClick={changeReportPosition}>Change position</button> */}
//     </div>
//   );

//   const header = (
//     <div className="header">
//       <div className="title">Power BI React component demo</div>
//     </div>
//   );

//   const footer = (
//     <div className="footer">
//       <div className="footer-text">
//         GitHub: &nbsp;
//         <a href="https://github.com/microsoft/PowerBI-client-react">
//           https://github.com/microsoft/PowerBI-client-react
//         </a>
//       </div>
//     </div>
//   );

//   return (
//     <div>
//       {/* <TopComponent position={position} /> */}
//       {/* {header} */}
//       <portals.InPortal node={portalNode}>
//         <PowerBIEmbed
//           embedConfig={sampleReportConfig}
//           eventHandlers={eventHandlersMap}
//           cssClassName={"report-style-class"}
//           getEmbeddedComponent={(embedObject) => {
//             console.log(
//               `Embedded object of type "${embedObject.embedtype}" received`
//             );
//             setReport(embedObject);
//           }}
//         />
//       </portals.InPortal>
//       {/* <MiddleComponent position={position} /> */}
//       <portals.OutPortal node={portalNode} />
//       {/* <div className="hr"></div>

//       <div className="displayMessage">{displayMessage}</div>

//       {controlButtons}

//       {footer} */}
//     </div>
//   );
// }

// export default PowerBIEmbeddedReport;
